import React from "react";
import "../../gazable-js/tdbrowse_web_components";
import GazableButtonType from "types/GazableButtonType";

const GazableButton = ({
  type,
  content,
  onClick,
  style,
  children,
}: GazableButtonType) => {
  return React.createElement(
    type,
    { key: "gazable-square-button", onClick, style }, // Pass style if defined
    content,
    children // Add children here
  );
};

export default GazableButton;
